import { MenuItem } from "@blueprintjs/core"
import CustomButton from "components/Atoms/CustomButton"
import CustomDialog from "components/Atoms/CustomDialog"
import Divider from "components/Atoms/Divider"
import StaticSelector from "components/Atoms/StaticSelector"
import StringInput from "components/Atoms/StringInput"
import ButtonMutation from "components/Molecules/ButtonMutation"
import UserSelector from "components/Templates/selectors/UserSelector"
import { COLOURS } from "data/static.items"
import { ADD_UPDATE_STORAGE_LOCATION } from "graphql/distribution-center/distribution-center.mutations.gql"
import { cloneDeep, set } from "lodash-es"
import React, { useEffect, useState } from "react"
import { ApolloErrorToast, SuccessToast } from "utils/AppToaster"
import useDCStore from "./dc.store"
const AddStorageLocationDialog = ({
  isOpen,
  onClose,
  item,
  refreshData,
  ...otherProps
}) => {
  const dcId = useDCStore(store => store.state.basicDetails.id)

  const [state, setState] = useState<any>({
    name: "",
    codename: "",
    subLocations: [],
  })

  useEffect(() => {
    if (item) {
      const stateCopy = cloneDeep(state)
      set(stateCopy, "id", item?.id)
      set(stateCopy, "name", item?.name)
      set(stateCopy, "codename", item?.codename)
      set(stateCopy, "subLocations", item?.subLocations)
      set(
        stateCopy,
        "colorCode",
        item?.colorCode
          ? COLOURS.filter(c => c.id === item?.colorCode)[0]
          : COLOURS[0]
      )
      set(stateCopy, "responsiblePerson", item?.responsiblePerson)
      setState(stateCopy)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item])

  function handleChange(path, value) {
    const stateCopy = cloneDeep(state)
    set(stateCopy, path, value)
    setState(stateCopy)
  }

  return (
    <CustomDialog
      grassUi
      title={"Add storage location"}
      isOpen={isOpen}
      footerRightButton={
        <ButtonMutation
          icon="confirm"
          text="Save"
          mutation={ADD_UPDATE_STORAGE_LOCATION}
          variables={{
            id: state?.id ? state?.id : undefined,
            distributionCentreId: dcId,
            name: state?.name,
            codename: state?.codename,
            colorCode: state?.colorCode?.id,
            responsiblePersonId: state?.responsiblePerson?.id,
            subLocations: state?.subLocations,
            archive: state?.archive ?? false,
          }}
          onError={err => {
            ApolloErrorToast(err)
          }}
          onCompleted={() => {
            refreshData(new Date().getTime())
            SuccessToast(`Storage location added successfully`)
            onClose()
          }}
        />
      }
      width="50%"
      onClose={onClose}
      {...otherProps}
    >
      <div>
        <div className="grid grid-cols-12 gap-4 mt-3">
          <div className="col-span-3">
            <StringInput
              label="Location name"
              placeholder="Enter info"
              path="name"
              value={state?.name}
              onChange={handleChange}
            />
          </div>
          <div className="col-span-3">
            <StringInput
              label="Abbreviation"
              placeholder="3 letters only"
              path="codename"
              value={state?.codename}
              onChange={handleChange}
            />
          </div>
          <div className="col-span-3">
            <StaticSelector
              big
              icon={
                <span
                  style={{
                    borderRadius: 4,
                    background: state?.colorCode?.id,
                    height: 14,
                    width: 14,
                  }}
                />
              }
              itemRenderer={(item, { handleClick, modifiers }) => {
                return (
                  <MenuItem
                    icon={
                      <span
                        style={{
                          borderRadius: 4,
                          background: item?.id,
                          height: 15,
                          width: 15,
                        }}
                      />
                    }
                    active={modifiers.active}
                    key={item.id}
                    onClick={handleClick}
                    text={item?.name}
                  />
                )
              }}
              label="Color"
              path="colorCode"
              items={COLOURS}
              value={state?.colorCode}
              onChange={handleChange}
            />
          </div>

          <div className="col-span-3">
            <UserSelector
              big
              value={state?.responsiblePerson}
              label="Person responsible"
              group="*"
              path="responsiblePerson"
              onChange={handleChange}
            />
          </div>
        </div>

        <CustomButton
          text="Add sublocation"
          icon="plus"
          onClick={() => {
            const stateCopy = cloneDeep(state)
            const subLocations = stateCopy.subLocations
            const subLocation = {
              name: "",
              codename: "",
              // responsiblePersonId: state?.responsiblePerson?.id,
              // distributionCentreId: id,
            }
            subLocations.push(subLocation)
            set(stateCopy, "subLocations", subLocations)
            setState(stateCopy)
          }}
        />
        {state.subLocations?.length > 0 ? (
          <>
            <Divider />
            {state.subLocations.map((subLocation, index) => (
              <div className="grid grid-cols-12 gap-4 mt-3" key={index}>
                <div className="col-span-5">
                  <StringInput
                    label="Location name"
                    placeholder="Enter info"
                    value={subLocation?.name}
                    onChange={(_, value) => {
                      const stateCopy = cloneDeep(state)
                      const subLocations = stateCopy.subLocations
                      subLocations[index].name = value
                      set(stateCopy, "subLocations", subLocations)
                      setState(stateCopy)
                    }}
                  />
                </div>
                <div className="col-span-5">
                  <StringInput
                    label="Abbreviation"
                    placeholder="3 letters only"
                    value={subLocation?.codename}
                    onChange={(_, value) => {
                      const stateCopy = cloneDeep(state)
                      const subLocations = stateCopy.subLocations
                      subLocations[index].codename = value
                      set(stateCopy, "subLocations", subLocations)
                      setState(stateCopy)
                    }}
                  />
                </div>
                {!subLocation?.id && (
                  <div className="col-span-2 d-center">
                    <CustomButton
                      minimal={true}
                      icon="trash"
                      intent="danger"
                      onClick={() => {
                        const stateCopy = cloneDeep(state)
                        stateCopy.subLocations.splice(index, 1)
                        setState(stateCopy)
                      }}
                    />
                  </div>
                )}
              </div>
            ))}
          </>
        ) : null}
      </div>
    </CustomDialog>
  )
}

export default AddStorageLocationDialog
